// Frontend/src/unicodex_ui/services/portalComplianceApi.js
import api from "./apiClient";

function cleanParams(params = {}) {
  const out = {};
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    if (typeof v === "string" && v.trim() === "") return;
    out[k] = v;
  });
  return out;
}

const portalComplianceApi = {
  async getOverview(params = {}) {
    const res = await api.get("/api/compliance/overview", { params: cleanParams(params) });
    return res.data; // { ok, range, verifications, riskEvents, shipments }
  },

  async getVerifications(params = {}) {
    const res = await api.get("/api/compliance/verifications", { params: cleanParams(params) });
    return res.data; // { ok, range, groupBy, rows }
  },

  async listRiskEvents(params = {}) {
    const res = await api.get("/api/compliance/risk-events", { params: cleanParams(params) });
    return res.data; // { ok, total, limit, offset, rows }
  },

  async listShipments(params = {}) {
    const res = await api.get("/api/compliance/shipments", { params: cleanParams(params) });
    return res.data; // { ok, total, limit, offset, rows }
  },
};

export default portalComplianceApi;
